const KEY = 'SPONDA_APP_SETTINGS';
const DEFAULT_OPTIONS = {
	language: 'fi',
	brochureType: 'tile',
	browseType: 'tile',
	browseSort: 'abc',
	loggedOutFrom: null,
};

class LocalStore {
	constructor() {
		this.options = { ...DEFAULT_OPTIONS };

		const local = localStorage.getItem(KEY);

		try {
			const parsedLocal = JSON.parse(local);
			this.options = parsedLocal === null ? { ...DEFAULT_OPTIONS } : parsedLocal;
		} catch(error) {
			console.warn('[Settings.js] Error parsing local value. Resetting to defaults.', error.message);
			this.set(DEFAULT_OPTIONS);
		}
	}

	store = () => localStorage.setItem(KEY, JSON.stringify(this.options));

	set = options => {
	  for(const key in options) {
	    if (this.validOption(key) && this.validate(key, options[key])) {
	      this.options[key] = options[key];
	    }
	  }

	  this.store();
	}

	validate = (key, value) => true; // TODO: maybe?

	get = key => {
	  if (this.validOption(key)) {
	    if (this.options[key]) {
	      return this.options[key];
	    } else {
	      return DEFAULT_OPTIONS[key];
	    }
	  }

	  return null;
	}

	clear = key => {
	  if (key in this.options) {
	    const oldValue = this.options[key];

	    this.options[key] = null;

	    this.store();

	    return oldValue;
	  }

	  return false;
	}

	validOption = key => Object.keys(DEFAULT_OPTIONS).includes(key);

}

export default new LocalStore();
